import {
  Dropdown,
  Form,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  MenuOutlined,
  HistoryOutlined
} from "@ant-design/icons";
import http from "@/utils/http";
import moment from "moment";
import api from "@/utils/api";
import dayjs from "dayjs";
import "./index.scss";
import PDFModal from "./component/PDFModal"
import { useLocation } from 'react-router-dom';
import commonFn from "@/utils/commonFn";
import AddModal from "@/views/AccountPayable/UtilityPayment/component/AddModal" ;
import ButtonList from "./component/ButtonList";
import { CustomTable, CustomTableExtend } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [selectedList, setSelectedList] = useState([]);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [periodList, setPeriodList] = useState([]);
  const [propTypeList, setPropTypeList] = useState([]);
  const [greater, setGreater] = useState([]);
  const [small, setSmall] = useState([]);

  const initTableHead = {
    vendorName: null,
    requestNumber: null,
    payAmount: null,
    requestStatus: null,
    perJobCost: null,
    requestStatusDate: null,
    requestEndDate: null,
    jobType: null,
    supervisor: null,
    needMaterial: null,
    materialAmount: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    // {
    //   title: '#',
    //   dataIndex: '#',
    // },
    {
      title: 'Prop',
      dataIndex: "prop",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      width:80,
      onChange: e => tableFilterFn(e, 'prop')
    },
    {
      title: 'Address',
      dataIndex: "addressCityState",
      titleType: 'Input',
      width:200,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'addressCityState')
    },
    {
      title: 'Prop Type',
      dataIndex: "propType",
      titleType: 'Select',
      width:80,
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: propTypeList,
      onChange: e => tableFilterFn(e, 'propType', 'Select'),
    },
    {
      title: 'Units',
      dataIndex: "units",
      titleType: '',
      width:60,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'units'),
    },
    {
      title: 'Gross Rent Received',
      dataIndex: "grossRentReceived",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: e => tableFilterFn(e, 'grossRentReceived'),
      render: text => {
        if (!text && text != 0) return "-"; // 处理空值
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(text); 
      },
    },
    {
      title: 'GL-Title',
      dataIndex: "glAcct",
      titleType: 'Input',
      width:120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'glAcct'),
    },
    {
      title: 'Total Pay Now',
      dataIndex: "amount",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: e => tableFilterFn(e, 'amount'),
      render: (text, record) => {
        if (text == null || text === "") return "-";
        return (
          <span
            onClick={() => handleAmountClick(record)}
            className="CA-AS-AmountStyle"
          >
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(text)}
          </span>
        );
      },
    },
    {
      title: 'Penalty Fee',
      dataIndex: "remark",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'remark'),
    },
    {
      title: 'Current Exp. Date',
      dataIndex: "expirationDate",
      titleType: 'DatePicker',
      isSorter: false,
      onChange: (e) => tableFilterFn(e, 'expirationDate', 'DatePicker'),
    },
    {
      title: 'Last Payment',
      dataIndex: "lastPayment",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      render:(text, record) => {
        const {latestPaymentAmount, latestPaymentDate, paymentColor} = record
        if (!latestPaymentAmount) {
          return <div>-</div>;
        }
        const colorMatch = {
          0: '#3c8dbc',
          1: '#dd4b39',
          2: 'green',
          3: '#f39c12',
        }
        const titleMatch = {
          0: "(Pending)",
          1: "(Not Cash)",
          2: "(Cashed)",
          3: "(Voided)",
        }
        const textColor = colorMatch[paymentColor] || "";
        const title = titleMatch?.[paymentColor] || ''
        return (
          // <div style={{ color: textColor, cursor: 'pointer' }} onClick={() =>  handleCellClick(record, true)}>
            <div style={{ color: textColor, cursor: 'pointer' }} >
            {title && <span style={{ 
              borderBottom: `1px dashed ${textColor}`,
              paddingBottom: '2px'
            }}>
              {title}
            </span> || null}
            <br />
            <span
              style={{
                borderBottom: `1px dashed ${textColor}`,
                paddingBottom: "2px",
              }}
            >
              {latestPaymentDate
                ? moment(latestPaymentDate).format("MM/DD/YYYY")
                : "-"}
            </span>
            <br />
            <span
              style={{
                borderBottom: `1px dashed ${textColor}`,
                paddingBottom: "2px",
              }}
            >
              {latestPaymentAmount
                ? new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2,
                  }).format(parseFloat(latestPaymentAmount))
                : "-"}
            </span>
          </div>
        )
      }
    },
    {
      title: "Rejected Reason",
      dataIndex: "rejectedReason",
      titleType: "Input",
      width: 150,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'rejectedReason'),
    },
    {
      title: 'Payee',
      dataIndex: "vendorName",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'vendorName'),
    },
    {
      title: 'Biz Lic #',
      dataIndex: "businessLicenseNumber",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'businessLicenseNumber'),
    },
    {
      title: 'Biz Name',
      dataIndex: "businessName",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'businessName'),
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  const setGreaterAndSmallFn = async(list = []) => {
    if(!list.length) return
    const ids = list.map(item => item.foreignId).join(",");
    const result = await http.get(api.ApprovalRecent, { params: { ids } });
    setGreater(result?.greater || []); 
    setSmall(result?.small || []); 
  }

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      email: new URLSearchParams(location.search).get("email"),
      transactionsType: new URLSearchParams(location.search).get("type"),
      batchGroup: new URLSearchParams(location.search).get("batchGroup"),
    };
    const response = await http.get(api.showBusinessLicense, { params });
    // setSelectedList([])
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setGreaterAndSmallFn(list)
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  //复选框
  const rowSelection = {
    selectedRowKeys: selectedList.map(item => item.vendorPaymentId),
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {}, 
      disabled: record.approve === "Waiting For Approval" 
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedList(selectedRows);
    },
  };

  const PDFModalRef = useRef();

  const handleAmountClick = (record) => {
    setCurrentRecord(record);
    PDFModalRef?.current?.setModalOpen(true);
  };
  
  const getDictionaryFn = async() => {
    const response = await http.get(api.getDictionary, { params: {
        type:'util_payment',
        value: 'propType'
    }});
    setPropTypeList(response)
  }

  const initColunmsFn = () => {
    setSelectedList([]);
    setTableHead(initTableHead);
    setColumns(initColumns);
  }
    
  useEffect(() => {
    getDictionaryFn()
  }, [])

  useEffect(() => {
    if(propTypeList?.length){
      setColumns(initColumns);
    }
  }, [propTypeList]);


  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

  const [addopen, setAddOpen] = useState(false);
  const [addRecord, setAddRecord] = useState(null);
  const [form] = Form.useForm();
  const [formTenant] = Form.useForm();

  const handleCellClick = async (record, flag = false) => {
    const response = await http.get(api.commonShowPayment, { params: {
      vendorPaymentId: record.latestPaymentId,
    }});
    const val = response.code === '1' ? response.data : {}
    const invoiceDateTemp = dayjs(flag ? val.invoiceDate : new Date())
    setAddRecord({ 
      ...record,
      ...val,
      vendorPaymentId: record.latestPaymentId,
      type: 'businessLicense',
      invoiceDate: invoiceDateTemp,
      amount: val?.amount || 0,
      serviceStartDate: val?.serviceStartDate && dayjs(val?.serviceStartDate) || null,
      serviceEndDate: val?.serviceEndDate && dayjs(val?.serviceEndDate) || null,
      invoiceTenant: String(val.invoiceTenant),
      foreignId: val?.foreignId || record?.vendorUtilPaymentId,
      filePaths: val?.filePaths || [],
      isEdit: flag,
      noSubmitBtn: true,
      usid: val?.usid
    });
    setAddOpen(true);
  };

  const downLoadFn = async () => {
    const params = {
      ...tableHead,
      email: new URLSearchParams(location.search).get("email"),
      transactionsType: new URLSearchParams(location.search).get("type"),
      batchGroup: new URLSearchParams(location.search).get("batchGroup"),
    }
    const blob = await http.get(api.exportBusinessLicenseCsv, {params, responseType: 'blob'});
    return {
      blob,
      name: `BusinessLicense`,
    };
  };

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('ApprovalDownload') && 'download']}
        downLoadFn={() => downLoadFn()}
      >
        <ButtonList
          email={new URLSearchParams(location.search).get("email")}
          transactionsType={new URLSearchParams(location.search).get("type")}
          moduleType={new URLSearchParams(location.search).get("module")}
          selectedList={selectedList}
          refreshTableFn={() => setRefreshKey(+new Date())}
        />
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          ...rowSelection,
        }}
        rowClassName={(record) => {
          if(greater.includes(record.vendorPaymentId)){
            return ["greater-row"]
          }
          if(small.includes(record.vendorPaymentId)){
            return "small-row"
          }
          return [record.vendorPaymentId]
        }}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="300px"
        tableCss="AS-tableClass"
      />

      <PDFModal ref={PDFModalRef} record={currentRecord} />

      <AddModal 
        addopen={addopen}
        form={form}
        formTenant={formTenant}
        handleModalSubmitlFn={() => {setAddOpen(false); getTableListFn(pagination.current, pagination.pageSize, tableHead)}}
        handleModalCancelFn={() => setAddOpen(false)}
        record={addRecord}
      />
    </div>
  );
});
export default MainTable;